import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { formatTo2Decimal, isEmptyArray } from '../../common/util.services';
import { getEnquiryCosting } from '../../costing/costing.services';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';

const SelectOrdPrdComponent = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const enquiryCode = props.enquiryCode;
  const [ordProduct, setOrdProduct] = useState(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [showMsgDialog, setShowMsgDialog] = useState(false);
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, width: 120 },
    { field: 'type', headerName: 'Type', filterable: false, sortable: false, width: 100 },
    { field: 'code', headerName: 'Costing Code', filterable: false, sortable: false, width: 130 },
    { field: 'description', headerName: 'Description', filterable: false, sortable: false, width: 200 },
    { field: 'inputCost', headerName: 'Input Cost', filterable: false, sortable: false, width: 100,
      valueFormatter: (inputCost: any) => formatTo2Decimal(inputCost)
    },
    { field: 'totalCost', headerName: 'Price', filterable: false, sortable: false, width: 100,
      valueFormatter: (totalCost: any) => formatTo2Decimal(totalCost)
    },
    { field: 'order', headerName: 'Order', filterable: false, sortable: false, width: 60 },
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getEnquiryCosting(enquiryCode, 0, 100, appContext,
        (response: any) => {
          setOrdProduct(response.data.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, []);

  const onRowSelection = () => {
    if(selectedRows.length < 1) {
      appContext.setDialogMessage('Select a row.');
    }
    else if(selectedRows[0].order > 0) {
      setShowMsgDialog(true);
    } else if (props.onRowSelection) {
      props.onRowSelection(selectedRows);
    }
  }

  const onOkClick = () => {
    if (props.onRowSelection) {
      props.onRowSelection(selectedRows);
    }
  }
  
  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = ordProduct.filter((row) =>
      selectedIds.has(row.rowId)
    );
    selectedRowData[0].costingCode = selectedRowData[0].code;
    setSelectedRows(selectedRowData);
  }

  return <div className='order-product'>
    <IGridComponent title='' showAddBtn={false} rows={ordProduct} columns={columns} maxHeight={"65vh"}
      getRowId={(row: any) => row.rowId} disableMultipleRowSelection={true} loading={loading}
      hideFooterPagination={true} checkboxSelection={true} hideFooter={false}
      showExtBtn={true} extBtnAction={onRowSelection} extBtnText={'Select'}
      disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange} />
    <YesNoDialog open={showMsgDialog} onClose={() => { setShowMsgDialog(false) }}
     onOk={() => { setShowMsgDialog(false); onOkClick(); }} isHorizontal={true} 
     message={'The product is present in another order. Do you want to continue?'}/>
  </div>
}

export default SelectOrdPrdComponent;